module.exports = __webpack_public_path__ + "img/4.3e3cf096.png";